import { z } from 'zod'

export const passwordRecoveryFormSchema = z.object({
  email: z.string().min(1, 'Obrigatório').email('E-mail inválido'),
})

export type PasswordRecoveryFormData = z.infer<
  typeof passwordRecoveryFormSchema
>
